
export const EntityViewTypes = {
    QUICK: 'quick',
    FULL: 'full',
}
